/** 后台数据接口在nginx的反向代理上下文，解决数据接口的跨域问题 */
const API_PROXY_PATH = '';
const ROUTER_BASE_PATH = '/bpm';

const dev = {
    port: 55555, // 开发服务器监听端口,
    // baseURL: 'http://39.107.229.85:13888/bcbpm'
    proxyURL: 'https://oa.bjzzrx.com/bcbpm',
    baseURL: '',
    activitiURL: 'https://oa.bjzzrx.com/bcbpm',
    routerBasePath: ''
//     proxyURL: 'http://localhost:8080/bcbpm',
//     baseURL: '',
//     activitiURL: 'http://localhost:8080/bcbpm',
//     routerBasePath: ''
};

const ci = {
    baseURL: API_PROXY_PATH,
    routerBasePath: ROUTER_BASE_PATH
};

const test = {
    baseURL: API_PROXY_PATH,
    routerBasePath: ROUTER_BASE_PATH
};

const pre = {
    baseURL: API_PROXY_PATH,
    routerBasePath: ROUTER_BASE_PATH
};

const prod = {
    baseURL: '/bcbpm',
    activitiURL: '/bcbpm',
    routerBasePath: ROUTER_BASE_PATH
};

// function config () {
//     // console.log(' process.env.NODE_ENV:', process.env.NODE_ENV);
//     // var env = window.sessionStorage.getItem('ENV') || 'dev';
//     let env = process.env.NODE_ENV;
//     if (env === 'production') {
//         return prod;
//     } else if (env === 'development') {
//         return Object.assign({}, {
//             baseURL: '/'
//         }, dev);
//     } else if (env === 'ci') {
//         return ci;
//     } else if (env === 'pre') {
//         return pre;
//     } else if (env === 'test') {
//         return test;
//     } else {
//         return prod;
//     }
// };

function config () {
    var env = window.sessionStorage.getItem('ENV') || 'dev';
    // var env = process.env.NODE_ENV;
    // console.log(`config ${window.sessionStorage.getItem('ENV')}`);
    if (env === 'product') {
        return prod;
    } else if (env === 'ci') {
        return ci;
    } else if (env === 'pre') {
        return pre;
    } else if (env === 'test') {
        return test;
    } else {
        return Object.assign({}, dev, {
            baseURL: '/',
            isDev: true,
            routerBasePath: ROUTER_BASE_PATH
            //            baseURL: '',
            //            isDev: true,
            //            routerBasePath: ''
        });
    }
};

module.exports = {
    /** 提供给打包脚本使用 */
    getDevConf: function () {
        return dev;
    },
    /** 提供给打包脚本使用 */
    getCiConf: function () {
        return ci;
    },
    /** 系统内容获取环境配置 */
    getConf: function () {
        return config();
    }
};



//////////////////
// WEBPACK FOOTER
// ./build/conf.js
// module id = 1227
// module chunks = 137